module.exports = __webpack_public_path__ + "img/headPortrait.d2169b90.png";